import { RouteItem } from '@eastcoal/router/types/route'

import { INQUIRY_AUCTION_CREATE_PAGE_PATH } from '../constants/path'

export const inquiryAuctionCreateRoute: RouteItem = {
  title: '新增询比价',
  hideInMenu: true,
  path: INQUIRY_AUCTION_CREATE_PAGE_PATH,
  Component: () => import('./index')
}
